import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "evChargerFilled"
const EvChargerFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.75 1.5C13.578 1.5 14.25 2.172 14.25 3V13.5H15.375C16.618 13.5 17.625 14.507 17.625 15.75V20.063C17.625 20.58 18.045 21 18.563 21 19.08 21 19.5 20.58 19.5 20.063V8.25H18.75C18.336 8.25 18 7.914 18 7.5V5.25C18 4.836 18.336 4.5 18.75 4.5V2.25H19.5V4.5H21V2.25H21.75V4.5C22.164 4.5 22.5 4.836 22.5 5.25V7.5C22.5 7.914 22.164 8.25 21.75 8.25H21V20.063C21 21.409 19.909 22.5 18.563 22.5 17.216 22.5 16.125 21.409 16.125 20.063V15.75C16.125 15.336 15.789 15 15.375 15H14.25V21Q14.25 21.078 14.242 21.153 14.226 21.3 14.185 21.435L14.16 21.508 14.137 21.568Q14.123 21.6 14.107 21.633 14.094 21.665 14.078 21.697 14.062 21.727 14.043 21.756L14.006 21.82 13.968 21.872 13.923 21.933 13.883 21.98Q13.858 22.011 13.828 22.042L13.79 22.08Q13.759 22.11 13.727 22.136L13.682 22.173Q13.65 22.2 13.616 22.223L13.566 22.257 13.504 22.295 13.446 22.328 13.367 22.365Q13.343 22.377 13.32 22.387 13.28 22.403 13.236 22.417 13.21 22.427 13.184 22.435 13.14 22.449 13.092 22.459L13.044 22.47Q12.9 22.5 12.75 22.5H3.75Q3.598 22.5 3.456 22.47L3.407 22.459Q3.361 22.449 3.315 22.435L3.264 22.417Q3.22 22.403 3.18 22.387 3.156 22.377 3.132 22.365L3.053 22.328Q3.023 22.312 2.996 22.295L2.935 22.258Q2.908 22.24 2.883 22.222 2.848 22.198 2.817 22.173L2.772 22.136 2.711 22.08 2.67 22.042 2.616 21.979 2.577 21.933 2.53 21.872 2.495 21.82 2.455 21.756Q2.44 21.726 2.423 21.697 2.406 21.666 2.392 21.633L2.361 21.568 2.34 21.508 2.314 21.435Q2.274 21.3 2.258 21.153L2.25 21V3C2.25 2.172 2.922 1.5 3.75 1.5zM9.345 8.83C9.413 8.437 8.954 8.2 8.675 8.44L8.62 8.496 5.754 11.97C5.548 12.219 5.698 12.599 6.019 12.64L7.562 12.84 7.155 15.17C7.082 15.589 7.61 15.83 7.879 15.505L10.746 12.032C10.952 11.782 10.802 11.401 10.481 11.36L8.937 11.16z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default EvChargerFilledIcon
